<template>

  <div class="parent-box" >
      <agreement v-if="showAgreement"   @close="showAgreement = false"></agreement>

      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
          <br />
          <br />
            
          <div class="modal-container">
            <div class="modal-header">
              <h1 class="close-btn" @click="$emit('close')">Close</h1>
            </div>
            <div class="modal-body">
              <div>
                <div class="heading">
                  <h2 class="login-title" v-show="activeIndex == 0">Product Information</h2>
                  <h2 class="login-title" v-show="activeIndex == 1">Job/ Business Information</h2>

                  <div  v-show="activeIndex == 0" class="main-body">
                    <h2>Arnergy 5000</h2>
                    <p>2 Battery + 12 panels on 1 Arnergy 5000 cabinet</p>
                    <div>
                      <h1 class="amt">Amount : #56,000 </h1>
                      <br />
                      <arnergy-select
                        v-model= "form.tenure"
                        label="Select Tenure"
                        :items="tenures"
                      />
                      <hr />
                      <div v-if="form.tenure" class="info-footer">
                      <p>Next Repayment Cost : #76,000 </p>
                      <p>Next Repayment Cost : #76,000 </p>
                    </div>
                  </div>
                </div>       
                <div  v-show="activeIndex == 1" class="main-body">
                  <div>
                    <arnergy-select
                      v-model= "form.employment"
                      label=""
                      :items="employmentStatus"
                    />
                    <arnergy-input
                      v-model="form.income"
                      :error="formErrors.income"
                      label="What's your monthly income ?"
                    />
                    <div>
                      <div v-show="form.employment == 'Self Employed'">
                      <arnergy-select
                        v-model= "form.business"
                        label="What's your business type ?"
                        :items="businessType"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <!-- form elements -->                
              <div v-show="activeIndex == 0">
                <div v-if="form.tenure">
                  <div v-if="modalstate" className="text-center">
                    <div class="submit-gif ">
                      <div class="spinner-border " style="width: 3rem; height: 3rem;" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <button @click="activeIndex= 1"  class="submit-button" type="button">
                      Next &rarr;
                    </button>
                  </div>
                </div>
                </div>
                <div v-show="activeIndex == 1">
                  <div v-if="form.tenure">
                    <div v-if="modalstate" className="text-center">
                      <div class="submit-gif ">
                        <div class="spinner-border " style="width: 3rem; height: 3rem;" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <button @click="$emit('closeToPopTerms')" class="submit-button" type="button">
                        Continue &rarr;
                      </button>
                    </div>
                    </div>
                  </div>     
                </div>
              </div>  
            </div>  
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import ArnergySelect from "../ArnergySelect.vue";
import Agreement from './Agreement';


export default {
  name: "Modal",
  props:['modalState'],
   components: {
    ArnergyInput,
    ArnergySelect,
    Agreement
   
  },
  computed: {},
  data() {
    return {
      costShow:false,
      showAgreement: false,
      activeIndex : 0,
      employmentStatus: [{id:'Employed', name: 'Employed' }, {id:'Self Employed', name: 'Self Employed' }],
      businessType: [{id:'Oil & Gas', name: 'Oil & Gas' }, {id:'Painter', name: 'Painter' }, {id: 'Trader', name: 'Trader'}],
      tenures: [{id:'6 Months tenure', name: '6 Months tenure' }, {id:'8 Months tenure', name: '8 Months tenure' },{id:'12 Months tenure', name: '12 Months tenure' }, {id:'9 Months tenure', name: '9 Months tenure'}],
      form: {
        tenure : '',
        income: '',
        employment:''
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },

    continuePage(){
     this.$emit('closeToPopTerms')


    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.modal-mask {
  margin-top: 30px;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;

}

.amt{
    font-size: 25px;
    color: $secondary-color;
    font-weight: bold;
}

.info-footer{
    float: left;
    margin-bottom: 3rem;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
height: 90vh;   
overflow-y : scroll;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn{
      color: orangered;
      font-size: 16px;
      position:absolute;
      top: 0;
      right: 0;
  }
}

.modal-body {
  margin: 20px 0;
  
}

.modal-default-button {
  float: right;
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}


.link {
  color: $primary-color;
  font-weight: bold;
}




.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif{
   display: block;
  color: white;
  width: 100%;
  text-align: center;
  color:white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;

}



</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/ModalComponent.vue